import { WSMutationConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_PAYEE } from "../../payee/keys";
import {
  QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
  QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
  QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE
} from "../keys";
import { IPayeeEngagementResponse } from "@wingspanhq/payments/dist/interfaces/api/payerPayeeEngagement";
import { queriesPayeeRows } from "@query";
import { updatePayeeEngagementByPayeeId } from "../../../services/payeeEngagement";
import { PayerPayeeEngagementStatus } from "@wingspanhq/payments/dist/interfaces";
import { QUERY_PAYEE_ROWS } from "../../search/payee/queries/useQueryPayeeRows";
import { QUERY_PAYEE_ROWS_SUMMARY } from "../../search/payee/queries/useQueryPayeeRowsSummary";
import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import {
  QUERY_REQUIREMENTS_FULL_LIST,
  QUERY_REQUIREMENTS_FULL_LIST_SIZE,
  QUERY_REQUIREMENTS_LIST
} from "../../requirements/keys";

type IPayeeEngagementArchiveParams = {
  payeeId: string;
  engagementIds: string[];
};

export const useMutationArchivePayeeEngagements = (
  config?: WSMutationConfig<IPayeeEngagementResponse[], WSServiceError>
) => {
  const xWingspanPayerId = useXWingspanPayerId();

  return useWSMutation(
    (request: IPayeeEngagementArchiveParams) => {
      const { engagementIds, payeeId } = request;

      return Promise.all(
        engagementIds.map(engagementId =>
          updatePayeeEngagementByPayeeId(
            payeeId,
            engagementId,
            {
              status: PayerPayeeEngagementStatus.Inactive
            },
            xWingspanPayerId
          )
        )
      );
    },
    {
      ...config,
      dependencies: [
        QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
        QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE,
        QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
        QUERY_PAYEE,
        QUERY_PAYEE_ROWS,
        QUERY_PAYEE_ROWS_SUMMARY,
        queriesPayeeRows.searchPayeeRows.queryKeyBase,
        QUERY_REQUIREMENTS_FULL_LIST,
        QUERY_REQUIREMENTS_FULL_LIST_SIZE,
        QUERY_REQUIREMENTS_LIST
      ]
    }
  );
};
